export const statusTextObj = {
    'authorizing' : 'Authorizing Payment through PayPal',
    'posting' : 'Authorization Complete Your Order Is Posting',
    'complete' : 'Your Order is Complete - Waiting on Inventory Refresh',
    'getting inventory' : 'Your Order is Complete - Refreshing Inventory',
}